module.exports = __webpack_public_path__ + "media/images/brands/hapier_page-31e5bef5df752d4904a067d7bdf7f157.png";